// =============================================================
// ⏰ PeakHoursChart.jsx — Picos de horário
// =============================================================

import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

export default function PeakHoursChart({ data }) {
  if (!data || data.length === 0) {
    return <div className="ia-chart-empty">Sem dados suficientes ainda.</div>;
  }

  return (
    <div className="ia-chart-wrapper">
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3c5d8" />
          <XAxis dataKey="hour" tick={{ fontSize: 11, fill: "#b22857" }} />
          <YAxis tick={{ fontSize: 11, fill: "#b22857" }} />
          <Tooltip />
          <Bar dataKey="count" fill="#f06292" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
